import React, { useEffect, useState, useMemo } from "react";
import {
  collection,
  doc,
  getDoc,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
} from "firebase/firestore";
import { db } from "../Config/Firebase";
import RefundDataViewModel from "../Assets/RefundDataViewModel";

const WithdrawalList = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [daysFilter, setDaysFilter] = useState("");
  const [sortOption, setSortOption] = useState("");

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
    const [detailsModalShow, setDetailsModalShow] = useState(false);

  const [itemToView, setItemToView] = useState(null);

  useEffect(() => {
    setLoading(true);

    const q = query(
      collection(db, "withdrawals"),
      orderBy("createdAt", "desc") 
    );

    const unsubscribe = onSnapshot(
      q,
      async (snapshot) => {
        try {
          const withdrawalWithUser = await Promise.all(
            snapshot.docs.map(async (docSnap) => {
              const data = docSnap.data();

              // Fetch user info
              const userRef = doc(db, "users", data.userId);
              const userSnap = await getDoc(userRef);
              const userData = userSnap.exists() ? userSnap.data() : {};

              return {
                docid: docSnap.id,
                id: docSnap.id,
                amountRupees: data.amountRupees,
                feeRupees: data.feeRupees,
                receiveRupees: data.receiveRupees,
                diamonds: data.diamonds,
                bankAccount: data.bankAccount,
                ifsc: data.ifsc || "N/A",
                method: data.method,
                upiId: data.upiId,
                status: data.status,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
                userName: userData.name || "Unknown User",
                userEmail: userData.email || "",
                mobile: userData.mobile || "",
                profileImageUrl: userData.profileImageUrl || "",
              };
            })
          );

          setWithdrawals(withdrawalWithUser);
        } catch (err) {
          console.error(err);
          setError("Failed to load withdrawals");
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error("Snapshot error:", err);
        setError("Failed to listen to withdrawals");
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, []);

  // Filtering 
  const filteredWithdrawals = useMemo(() => {
    const today = new Date();
    let filtered = withdrawals.filter((w) => {
      const nameMatch = w.userName?.toLowerCase().includes(search.toLowerCase());
      const emailMatch = w.userEmail?.toLowerCase().includes(search.toLowerCase());
      const mobileMatch = w.mobile?.toLowerCase().includes(search.toLowerCase());

      let matchesDate = true;
      if (daysFilter) {
        let createdDate;

        
        if (typeof w.createdAt === "number") {
          createdDate = new Date(w.createdAt); 
        } else if (w.createdAt?.seconds) {
          createdDate = new Date(w.createdAt.seconds * 1000); 
        } else if (typeof w.createdAt === "string") {
          createdDate = new Date(w.createdAt);
        }

        if (createdDate && !isNaN(createdDate)) {
          const diffTime = today - createdDate;
          const diffDays = diffTime / (1000 * 60 * 60 * 24);
          matchesDate = diffDays <= parseInt(daysFilter);

        } else {
          matchesDate = false;
        }
      }

      return (nameMatch || emailMatch || mobileMatch) && matchesDate;
    });

    if (sortOption === "name-asc") {
      filtered.sort((a, b) => (a.userName || "").localeCompare(b.userName || ""));
    } else if (sortOption === "name-desc") {
      filtered.sort((a, b) => (b.userName || "").localeCompare(a.userName || ""));
    } else if (sortOption === "date-asc") {
      filtered.sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
        return dateA - dateB;
      });
    } else if (sortOption === "date-desc") {
      filtered.sort((a, b) => {
        const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
        const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
        return dateB - dateA;
      });
    }

    return filtered;
  }, [withdrawals, search, daysFilter, sortOption]);

  // Pagination
  const totalPages = Math.ceil(filteredWithdrawals.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentWithdrawals = filteredWithdrawals.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;



        const handleViewClick = (id) => {
      setItemToView(id);
      setDetailsModalShow(true);
    };



        const cancelView = () => {
      setDetailsModalShow(false);
      setItemToView(null);
    };

  return (
    <div className="Fee-Details-Container">
      <h2 className="text-xl font-semibold mb-4">Withdrawals List</h2>

      
      <div className="flex justify-end flex-wrap gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by name, email, or mobile..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          className="px-4 py-2 border rounded"
        />

        
        <select
          value={daysFilter}
          onChange={(e) => {
            setDaysFilter(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">All Dates</option>
          <option value="1">Last 1 Day</option>
          <option value="7">Last 7 Days</option>
          <option value="30">Last 30 Days</option>
          <option value="182">Last 6 Months</option>
          <option value="365">Last 1 Year</option>
        </select>

        
        <select
          value={sortOption}
          onChange={(e) => {
            setSortOption(e.target.value);
            setCurrentPage(1);
          }}
          className="px-2 py-1 border rounded"
        >
          <option value="">Sort None</option>
          <option value="name-asc">Name Asc</option>
          <option value="name-desc">Name Desc</option>
          <option value="date-asc">Date Asc</option>
          <option value="date-desc">Date Desc</option>
        </select>
      </div>

      {/* Table */}
      <table className="w-full text-sm border refund-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">Name </th>
            <th className="px-4 py-2 text-left">Account Balance</th>
            <th className="px-4 py-2 text-left">Request Balance</th>
            <th className="px-4 py-2 text-left">Method</th>
            <th className="px-4 py-2 text-left">Date</th>
            <th className="px-4 py-2 text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {currentWithdrawals.length > 0 ? (
            currentWithdrawals.map((w, index) => (
              <tr key={w.id} className="border-t">
                <td className="px-4 py-2 flex flex-wrap items-center gap-3">
                  <img
                    src={w.profileImageUrl || "https://via.placeholder.com/40"}
                    alt="avatar"
                    className="w-10 h-10 rounded-full"
                  />
                  <span>{w.userName}</span>
                </td>
                
                <td className="px-4 py-2">₹{w.amountRupees || 0}</td>
                <td className="px-4 py-2">₹{w.receiveRupees || 0}</td>
                <td className="px-4 py-2">{w.method || "N/A"}<br />( {w.method === "Bank Account"? (w.bankAccount || "N/A") : (w.upiId || "N/A")})</td>
                <td className="px-4 py-2">{formatDateTime(w.createdAt)}</td>
                <td
                  className={`px-4 py-2 font-semibold cursor-pointer ${
                    w.status?.toLowerCase() === "successful"
                      ? "text-green-600"
                      : w.status?.toLowerCase() === "pending"
                      ? "text-yellow-500"
                      : "text-red-600"
                  }`}
                  onClick={() => handleViewClick(w.docid)}
                >
                  {w.status}
                  
                </td>

                
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center py-4 text-gray-500">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      {detailsModalShow && (
        <RefundDataViewModel
          user={currentWithdrawals.find((p) => p.docid === itemToView) || null}
          onClose={cancelView}
          onUpdateStatus={(userId, newStatus) => {
            
            updateDoc(doc(db, "withdrawals", userId), { status: newStatus })
              .then(() => console.log("Status updated successfully"))
              .catch((err) => console.error("Error updating:", err));
              setDetailsModalShow(false);
              setItemToView(null);
          }}
        />
      )}
    </div>
  );
};

export default WithdrawalList;

// Format 
const formatDateTime = (value) => {
  if (!value) return "";
  let date;
  if (typeof value === "number") {
    date = new Date(value);
  } else if (value?.seconds) {
    date = new Date(value.seconds * 1000);
  } else if (typeof value === "string") {
    date = new Date(value);
  } else {
    return "";
  }
  if (isNaN(date.getTime())) return "";
  return date.toLocaleString(); 
};
